<template>
  <card id="gatewayConfigurationVpn" :title="$t('gc-vpn:vpn')" no-footer>
    <div slot="card-body">
      <label for="configVpn" class="control-label">{{ $t('gc-vpn:vpnConfiguration') | capitalize }}</label>
      <textarea id="configVpn"
                v-model="vpn.configVpn"
                class="form-control"
                disabled
      />
    </div>
  </card>
</template>

<script>
import { isEmpty } from 'lodash-es'
import { mapGetters } from 'vuex'
import to from '@/modules/await-to-js'
import eventBus from '@/modules/eventBus'

export default {
  titleKey: 'gatewayConfVpn',

  props: {
    eui: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      vpn: {},
      getting: false,
      sending: false
    }
  },

  computed: {
    ...mapGetters(['gateway']),

    disabled () {
      return isEmpty(this.vpn) || this.sending
    }
  },

  watch: {
    eui () {
      // Reset data, and get data from new gateway
      this.vpn = {}
    },

    gateway () {
      // Do not refresh is we olready have the data
      if (!isEmpty(this.vpn) || this.getting) return

      this.getVpn()
    }
  },

  created () {
    this.getVpn()
  },

  methods: {
    async getVpn () {
      if (isEmpty(this.gateway)) return

      if (!this.gateway.connection) {
        eventBus.$emit('message-info', this.$t('gc-vpn:gatewayNotConnected'))
        return
      }

      this.getting = true

      let error, response
      [error, response] = await to(this.$api.getGatewayCurrentConfiguration(this.gateway, { groups: 'vpn' }))

      if (error || !response) {
        this.getting = false
        return
      }

      this.vpn = response.data
      this.getting = false
    }
  }
}
</script>

<style scoped lang="scss">
  @import "~@/scss/variables";

  textarea {
    height: 50vh;
    font-family: monospace;
  }
</style>
